import { alpha } from '@mui/material';
export const useUpcomingEventCardStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 3,
            py: (theme) => theme.spacing(2),
            px: (theme) => theme.spacing(2.5),
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
            gap: 2,
            cursor: 'pointer'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: (theme) => theme.spacing(0.5)
        }
    };
};
